import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const atMenus = () => {
    const basePath = getDomainConfig(getLocale('de-AT').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: basePath
                    ? 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg'
                    : 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blte1a2093713009033/weltsparen-logo.svg',
                alt: 'WeltSparen',
            },
        ],
        navItems: [
            {
                id: '7c70fbcc-4e00-4fe1-8b47-87251d3534b5',
                title: 'Sparen',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: '9d42c71e-7190-4618-b581-38951fbcf547',
                            type: 'advanced',
                            title: 'Tagesgeld',
                            href: `${basePath}/tagesgeld/`,
                            description: 'Flexible Einlage ohne feste Laufzeit und mit variablem Zinssatz',
                            icon: 'overnightMoneyIcon',
                            iconColor: '#9CD3E4',
                        },
                        {
                            id: '76d1f169-c6a1-495e-a495-5fcc74f131ca',
                            type: 'advanced',
                            title: 'Festgeld',
                            href: `${basePath}/festgeld/`,
                            description: 'Termineinlage mit fester Laufzeit und festem Zins',
                            icon: 'fixedDepositIcon',
                            iconColor: '#61AFD2',
                        },
                    ],
                    sidebar: [
                        {
                            id: '948a7d90-538e-4810-98a5-cb62b90055e4',
                            type: 'image',
                            title: 'Flexgeld',
                            href: `${basePath}/flexgeld/`,
                            imageUrl: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb9eb31e6bcd69b34/Image_Tagesgeld-Vergleich.png',
                            description: 'Flexgeld',
                        },
                        {
                            id: '6314a93e-bfa2-4e98-a5fe-4812e449f16d',
                            type: 'arrow',
                            title: 'Festgeld 2 Jahre',
                            href: `${basePath}/festgeld/vergleich/2-jahre/`,
                        },
                        {
                            id: 'f922087f-44b4-4ce6-a1ca-eedc5179ddf7',
                            type: 'arrow',
                            title: 'Festgeld 1 Jahr',
                            href: `${basePath}/festgeld/vergleich/1-jahr/`,
                        },
                        {
                            id: '92cc3567-863e-488a-8b25-05ecec2a8506',
                            type: 'arrow',
                            title: 'Festgeld 6 Monate',
                            href: `${basePath}/festgeld/vergleich/6-monate/`,
                        },
                    ],
                },
            },
            {
                id: 'f149e12f-3a9f-44e3-a75e-ae1a37e12c64',
                title: 'Finanzwissen',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'e78780a1-cc15-45d9-95ca-53c52e905cc5',
                            type: 'advanced',
                            title: 'Sparen',
                            href: `${basePath}/sparen/`,
                            description: 'Erspartes Geld für höhere Zinsen risikofrei einlegen',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt47d6d4d59810852a/Sparen.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '2a134210-7e96-4614-b940-318c010b7a0a',
                            type: 'advanced',
                            title: 'Geldanlage',
                            href: `${basePath}/geldanlage/`,
                            description: 'Wertschwankungen in Kauf nehmen, um langfristig höhere Renditen zu realisieren',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blta8cc8459997e3a6c/Geldanlage.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: 'f6179f6a-30ed-4b55-a6b0-0997bb6accc8',
                            type: 'advanced',
                            title: 'Steuerinformationen',
                            href: `${basePath}/steuer/`,
                            description: 'Informationen zur steuerlichen Behandlung von Geldanlagen',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt36b69e61c2b0a979/Steuerinformation.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '5d4de868-91cd-42cc-9358-08173aa5986f',
                            type: 'advanced',
                            title: 'Einlagensicherung',
                            href: `${basePath}/einlagensicherung/`,
                            description: 'Alles Wichtige rund um die Einlagensicherungssysteme in Europa',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt8e96e15c429c928b/Einlagensicherung.svg',
                            iconColor: '#0E6CC5',
                        },
                    ],
                    sidebar: [
                        {
                            id: '682a68af-d0c3-4f6f-8aa4-0b4752040b0e',
                            type: 'image',
                            title: 'Geld sparen',
                            href: `${basePath}/sparen/geld-sparen/`,
                            imageUrl: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt55dabdac421526a4/Image_Sparen.png',
                            description: 'Geld sparen',
                        },
                        {
                            id: 'f10ea65e-7827-42c9-a681-c0b214aeb11d',
                            type: 'arrow',
                            title: 'Monatlich sparen',
                            href: `${basePath}/sparen/monatlich-sparen/`,
                        },
                        {
                            id: '94216326-d1cb-4afe-9e1e-543421f52d57',
                            type: 'arrow',
                            title: 'Sparbuch',
                            href: `${basePath}/sparen/sparbuch/`,
                        },
                        {
                            id: '6f4a40db-578f-4f8f-becc-cd50da44efb4',
                            type: 'arrow',
                            title: 'Sparkonto',
                            href: `${basePath}/sparen/sparkonto/`,
                        },
                    ],
                },
            },
            {
                id: 'b1ef9202-f58c-4f98-a3fe-b4178a842ecb',
                title: 'Hilfe',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'a9cbf2ad-81bc-4f83-8196-b67b414f9b0f',
                            type: 'text',
                            title: 'So funktioniert’s',
                            href: `${basePath}/so-funktionierts/`,
                        },
                        {
                            id: '9a91930e-db2a-45be-8eab-30a081e40e03',
                            type: 'text',
                            title: 'Banken',
                            href: `${basePath}/bank/`,
                        },
                        {
                            id: 'f7c75a69-3287-483f-912f-d4c2432a0708',
                            type: 'text',
                            title: 'Kundenservice',
                            href: `${basePath}/kontakt/`,
                        },
                        {
                            id: 'b16af5c5-2320-4317-80fa-fc2a375eb79c',
                            type: 'text',
                            title: 'Häufig gestellte Fragen',
                            href: 'https://kundenservice.weltsparen.at/hc/de/',
                        },
                    ],
                },
            },
        ],
        actionItems: [
            {
                id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
                title: 'Anmelden',
                href: `${basePath}/login/`,
                type: 'login',
            },
            {
                id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
                title: 'Registrieren',
                href: `${basePath}/register/`,
                type: 'registration',
            },
        ],
    };
};
//# sourceMappingURL=atMenus.js.map